import { render, staticRenderFns } from "./treatyDialog.vue?vue&type=template&id=7ac77e1b&scoped=true&"
import script from "./treatyDialog.vue?vue&type=script&lang=js&"
export * from "./treatyDialog.vue?vue&type=script&lang=js&"
import style0 from "./treatyDialog.vue?vue&type=style&index=0&id=7ac77e1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac77e1b",
  null
  
)

export default component.exports